/** @format */

import {parseISO} from 'date-fns';

import {getMonthGenitive} from 'helpers/dateHelpers';

const getDetailedDateText = (date: string, includeYear: boolean): string => {
  const parsed = parseISO(date);
  const day = parsed.getDate();
  const monthString = getMonthGenitive(parsed.getMonth());
  const year = includeYear ? ` ${parsed.getFullYear()}` : '';
  return `${day} ${monthString}${year}`;
};

export {getDetailedDateText};
